import { computed, onBeforeUnmount, onMounted, ref } from "vue";

import { resolveRoute } from "./routes";

const pathname = ref(globalThis.location?.pathname ?? "/");

export function setRoutePathname(nextPathname: string): void {
  pathname.value = nextPathname;
}

function updateRoute(): void {
  const nextPathname = window.location.pathname;
  const routeChanged = pathname.value !== nextPathname;
  pathname.value = nextPathname;
  if (routeChanged) window.scrollTo({ top: 0, behavior: "instant" });
}

export function navigate(path: string): void {
  if (window.location.pathname === path) {
    window.scrollTo({ top: 0, behavior: "instant" });
    return;
  }
  window.history.pushState({}, "", path);
  updateRoute();
}

export function useRoute() {
  const route = computed(() => resolveRoute(pathname.value));
  onMounted(() => window.addEventListener("popstate", updateRoute));
  onBeforeUnmount(() => window.removeEventListener("popstate", updateRoute));
  return route;
}

export function installLinkInterception(event: MouseEvent): void {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = event.target as Element | null;
  const anchor = target?.closest<HTMLAnchorElement>("a[data-route]");
  if (!anchor || anchor.target || anchor.origin !== window.location.origin) return;
  event.preventDefault();
  navigate(anchor.pathname);
}
